import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import MicroApp from '../components/MicroApp';
import useMicroServicesTools from '../hooks/use-micro-services-tools';
import useMerchantSettings from '../hooks/use-merchant-settings';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',
};

const loadingContainerStyle = {
  ...containerStyle,
  justifyContent: 'center',
  alignItems: 'center',
};

const upsellStyle = {
  display: 'grid',
  width: '100%',
  height: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  overflow: 'hidden',
};

function Loading() {
  return (
    <div style={loadingContainerStyle}>
      <Spin />
    </div>
  );
}

export function UpsellApp() {
  const location = useLocation();
  const fullPath = `${location.pathname}${location.search}`;
  const microServicesTools = useMicroServicesTools('upsell');
  const containerRef = useRef(null);

  const { isLoading: isLoadingSettings, merchantSettings } =
    useMerchantSettings();

  if (isLoadingSettings) {
    return <Loading />;
  }

  return (
    <div ref={containerRef} style={containerStyle}>
      <MicroApp
        name="upsell"
        style={upsellStyle}
        loading={<Loading />}
        settings={merchantSettings}
        mountPath="/upsell"
        pathAndQuery={fullPath}
        useHashHistory={false}
        {...microServicesTools}
      />
    </div>
  );
}
